import MarkdownIt from 'markdown-it';
import plainText from 'markdown-it-plain-text';
import xss from 'xss';

export function renderMd(value: string) {
    const md = new MarkdownIt().use(plainText) as MarkdownIt & { plainText: string };
    md.render(value);
    return xss(md.plainText);
}
